export const INVESTOR_TYPES = [
  "Angel investor",
  "Angel syndicate",
  "Venture capital",
  "Family office",
  "Strategic investor",
  "Education investor",
  "Impact investor",
  "Accelerator",
  "Crowdfunding platform",
  "Grant or public funding body",
  "Other",
].map((v) => ({ value: v, label: v }));

export const INVESTOR_STAGES = [
  "Pitch deck sent / Applied",
  "Email outreach sent",
  "Response received",
  "Meeting scheduled",
  "Due diligence",
  "Negotiating",
  "Invested",
  "Passed / Not proceeding",
];

export const INVESTOR_STAGE_OPTS = INVESTOR_STAGES.map((v) => ({ value: v, label: v }));

export const INVESTOR_PRIORITY = [
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
  { value: "Critical", label: "Critical" },
];

export const INTERACTION_TYPES = [
  "Research note",
  "Email sent",
  "Email received",
  "Phone call",
  "Introductory meeting",
  "Follow-up meeting",
  "Pitch sent",
  "Pitch delivered",
  "Documents sent",
  "Due diligence",
  "Negotiation",
  "Other",
].map((v) => ({ value: v, label: v }));

export const DOCUMENT_LABELS = [
  "Pitch deck",
  "Executive summary",
  "Financial model",
  "Business plan",
  "Demo link",
  "Product screenshots",
  "Cap table",
  "Investment terms",
  "Other",
];

export const ACTIVE_STAGES = ["Pitch deck sent / Applied", "Email outreach sent", "Response received", "Meeting scheduled", "Due diligence", "Negotiating"];
export const CLOSED_STAGES = ["Passed / Not proceeding", "Invested"];

export const stageBadge = (stage) =>
  ({
    "Pitch deck sent / Applied": "info",
    "Email outreach sent": "warning",
    "Response received": "warning",
    "Meeting scheduled": "info",
    "Due diligence": "info",
    Negotiating: "warning",
    Invested: "success",
    "Passed / Not proceeding": "neutral",
  }[stage] || "neutral");

export const priorityBadge = (p) =>
  ({ Low: "info", Medium: "info", High: "warning", Critical: "error" }[p] || "neutral");

export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(Number(n) || 0);

export const isFollowupDue = (i, today) =>
  !!i.next_follow_up_date && i.next_follow_up_date <= today && !CLOSED_STAGES.includes(i.stage);

export const isOverdueFollowup = (i, today) =>
  !!i.next_follow_up_date && i.next_follow_up_date < today && !CLOSED_STAGES.includes(i.stage);

export const hasNoNextAction = (i) =>
  !CLOSED_STAGES.includes(i.stage) && !(i.next_action && i.next_action.trim());
